import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.trim() || "";
export const API_BASE = BACKEND_URL
  ? `${BACKEND_URL.replace(/\/$/, "")}/api`
  : "/api";

const api = axios.create({ baseURL: API_BASE, timeout: 20000 });

api.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = window.localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const fetchClients = () => api.get("/clients").then((r) => r.data);
export const fetchHomeHeroContent = () => api.get("/home-hero-content").then((r) => r.data);
export const loginAdmin = (credentials) => api.post("/admin/login", credentials).then((r) => r.data);
export const changeAdminPassword = (payload) => api.post("/admin/change-password", payload).then((r) => r.data);
export const fetchAdminMe = () => api.get("/admin/me").then((r) => r.data);
export const fetchAdminDashboard = () => api.get("/admin/dashboard").then((r) => r.data);
export const fetchAdminHomeHeroContent = () => api.get("/admin/home-hero-content").then((r) => r.data);
export const updateAdminHomeHeroContent = (payload) => api.put("/admin/home-hero-content", payload).then((r) => r.data);
export const createAdminProduct = (payload) => api.post("/admin/products", payload).then((r) => r.data);
export const updateAdminProduct = (slug, payload) => api.put(`/admin/products/${slug}`, payload).then((r) => r.data);
export const deleteAdminProduct = (slug) => api.delete(`/admin/products/${slug}`).then((r) => r.data);
export const createAdminClient = (payload) => api.post("/admin/clients", payload).then((r) => r.data);
export const fetchAdminClients = () => api.get("/admin/clients").then((r) => r.data);
export const deleteAdminClient = (clientId) => api.delete(`/admin/clients/${clientId}`).then((r) => r.data);
export const fetchAdminTestimonials = () => api.get("/admin/testimonials").then((r) => r.data);
export const createAdminTestimonial = (payload) => api.post("/admin/testimonials", payload).then((r) => r.data);
export const deleteAdminTestimonial = (testimonialId) => api.delete(`/admin/testimonials/${testimonialId}`).then((r) => r.data);
export const fetchAdminInquiries = (params = {}) => api.get("/admin/inquiries", { params }).then((r) => r.data);
export const fetchAdminInboxEmails = (params = {}) => api.get("/admin/inbox-emails", { params }).then((r) => r.data);
export const fetchAdminSentEmails = (params = {}) => api.get("/admin/mailbox/sent", { params }).then((r) => r.data);
export const fetchAdminOutboxEmails = (params = {}) => api.get("/admin/mailbox/outbox", { params }).then((r) => r.data);
export const saveAdminOutboxDraft = (payload) => api.post("/admin/mailbox/outbox", payload).then((r) => r.data);
export const deleteAdminOutboxDraft = (draftId) => api.delete(`/admin/mailbox/outbox/${draftId}`).then((r) => r.data);
export const sendAdminMailboxEmail = (payload) => api.post("/admin/mailbox/send", payload).then((r) => r.data);
export const updateAdminInquiry = (id, payload) => api.patch(`/admin/inquiries/${id}`, payload).then((r) => r.data);
export const deleteAdminInquiry = (id) => api.delete(`/admin/inquiries/${id}`).then((r) => r.data);
export const sendAdminInquiryEmail = (id, payload) => api.post(`/admin/inquiries/${id}/send-email`, payload).then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);

export const logoutAdmin = () => {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem("admin_token");
  }
};

export default api;

